module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-77.44b6071.woff2";